module.exports = __webpack_public_path__ + "img/leaving-queue.5d306264.svg";